import { CalculationResult } from "@/utils/calculationUtils";
import { Clock, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface CalculationResultsProps {
  result: CalculationResult;
}

export const CalculationResults = ({ result }: CalculationResultsProps) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="p-4 bg-white/10 rounded-lg border border-white/20">
        <h3 className="font-medium mb-2 text-white">Your Potential Savings</h3>
        <div className="space-y-2 text-sm">
          <p className="flex justify-between text-gray-300">
            <span>Monthly Savings:</span>
            <span className="font-semibold text-white">R{result.monthlySavings.toFixed(2)}</span>
          </p>
          <p className="flex justify-between text-gray-300">
            <span>Yearly Savings:</span>
            <span className="font-semibold text-white">R{result.yearlySavings.toFixed(2)}</span>
          </p>
          <p className="flex justify-between text-gray-300">
            <span>New Monthly Repayment:</span>
            <span className="font-semibold text-white">R{result.newRepayment.toFixed(2)}</span>
          </p>
          <p className="text-center text-gray-300 mt-2">
            That's a <span className="font-semibold text-white">{result.reductionPercentage.toFixed(2)}%</span>{" "}
            reduction in your obligations!
            {result.urgentSubmission && (
              <span className="flex items-center justify-center gap-1 text-green-400 mt-1">
                <Clock className="w-3 h-3" />
                Includes 5% urgent submission bonus!
              </span>
            )}
          </p>
        </div>
      </div>
      {!result.urgentSubmission && (
        <div className="space-y-4">
          <div className="text-xs text-gray-400 text-center">
            <p>Submit all required documents within 24 hours to qualify for an additional 5% reduction!</p>
          </div>
          <Button
            onClick={() => navigate('/dashboard/documents')}
            className="w-full flex items-center justify-center gap-2 bg-[#9b87f5] hover:bg-[#7E69AB] text-white transition-colors"
            variant="ghost"
          >
            <FileText className="w-4 h-4" />
            Upload Documents Now
          </Button>
        </div>
      )}
    </div>
  );
};